module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-videos"
  }, [_c('div', {
    attrs: {
      "id": "videos"
    }
  }), _vm._l((_vm.props), function(cluster, j) {
    return _c('div', {
      key: "j",
      staticClass: "custom-videos__tabs"
    }, [_c('div', {
      staticClass: "custom-videos__desktop"
    }, _vm._l((cluster.videos), function(video, i) {
      return _c('div', {
        staticClass: "custom-videos__tab",
        class: {
          'custom-videos__tab--active': _vm.hoverTab === i
        },
        style: ({
          backgroundImage: 'url(' + video.image + ')'
        }),
        on: {
          "mouseover": function($event) {
            _vm.hoverTab = i
          },
          "mouseleave": function($event) {
            _vm.hoverTab = i
          },
          "click": function($event) {
            return _vm.loadVideo(i, j)
          }
        }
      }, [_c('div', {
        staticClass: "custom-videos__overlay"
      }), _c('div', {
        staticClass: "custom-videos__title",
        domProps: {
          "innerHTML": _vm._s(video.title)
        }
      }), _c('transition', {
        attrs: {
          "name": "fade-in-tab-text"
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.hoverTab === i),
          expression: "hoverTab === i"
        }],
        staticClass: "custom-videos__title--active",
        domProps: {
          "innerHTML": _vm._s(video.title)
        }
      })]), _c('transition', {
        attrs: {
          "name": "fade-in-tab-text"
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.hoverTab === i),
          expression: "hoverTab === i"
        }],
        staticClass: "custom-videos__content",
        domProps: {
          "innerHTML": _vm._s(video.content)
        }
      })])], 1)
    }), 0), _c('div', {
      staticClass: "custom-videos__mobile"
    }, _vm._l((cluster.videos), function(video, i) {
      return _c('div', {
        staticClass: "custom-videos__mobile-tab",
        class: {
          'custom-videos__mobile-tab--active': _vm.mobileTabs.includes(i)
        },
        style: ({
          backgroundImage: 'url(' + video.image + ')'
        }),
        on: {
          "click": function($event) {
            return _vm.toggleMobileTab(i)
          }
        }
      }, [_c('div', {
        staticClass: "custom-videos__mobile-overlay"
      }), _c('div', {
        staticClass: "custom-videos__mobile-label"
      }, [_c('div', {
        staticClass: "custom-videos__mobile-selector"
      }, [_c('transition', {
        attrs: {
          "name": "fade-in-label"
        }
      }, [(!_vm.mobileTabs.includes(i)) ? _c('div', {
        staticClass: "custom-videos__mobile-selector--plus"
      }, [_vm._v("+")]) : _vm._e()]), _c('transition', {
        attrs: {
          "name": "fade-in-label"
        }
      }, [(_vm.mobileTabs.includes(i)) ? _c('div', {
        staticClass: "custom-videos__mobile-selector--minus"
      }, [_vm._v("-")]) : _vm._e()])], 1), _c('div', {
        staticClass: "custom-videos__mobile-title",
        domProps: {
          "innerHTML": _vm._s(video.title)
        }
      })]), _c('transition', {
        attrs: {
          "name": "fade-in-label"
        }
      }, [(_vm.mobileTabs.includes(i)) ? _c('div', {
        staticClass: "custom-videos__mobile-content",
        domProps: {
          "innerHTML": _vm._s(video.content)
        }
      }) : _vm._e()]), _c('transition', {
        attrs: {
          "name": "fade-in-label"
        }
      }, [(_vm.mobileTabs.includes(i)) ? _c('div', {
        staticClass: "custom-videos__mobile-play-video",
        on: {
          "click": function($event) {
            return _vm.loadVideo(i, j)
          }
        }
      }, [_c('span', [_vm._v("<< Play Video >>")])]) : _vm._e()])], 1)
    }), 0), _vm._l((cluster.videos), function(video, i) {
      return _c('div', {
        staticClass: "custom-videos__video-player-wrapper",
        class: {
          'custom-videos__video-player-wrapper--active': _vm.openVideoPlayer === i, 'custom-videos__video-player-wrapper--playing': _vm.videoPlaying === true
        }
      }, [_c('div', {
        staticClass: "custom-videos__video-player-bg"
      }, [_c('div', {
        staticClass: "custom-videos__video-player-close-btn",
        on: {
          "click": function($event) {
            return _vm.closeVideo(i, j)
          }
        }
      }, [_c('span'), _c('span')]), _c('video', {
        staticClass: "custom-videos__video-player-video",
        attrs: {
          "controls": "controls",
          "poster": video.poster,
          "id": 'video-' + j + '' + i
        }
      }, [_c('source', {
        directives: [{
          name: "load-directive",
          rawName: "v-load-directive"
        }],
        attrs: {
          "src": video.src,
          "type": "video/mp4"
        }
      }), _vm._v("Your browser does not support video.")]), _c('div', {
        staticClass: "custom-videos__video-player-poster-ctnr",
        class: {
          'custom-videos__video-player-poster-ctnr--playing': _vm.videoPlaying === true
        },
        on: {
          "click": function($event) {
            return _vm.playVideo(i, j)
          }
        }
      }, [_c('img', {
        staticClass: "custom-videos__video-player-poster",
        attrs: {
          "src": video.poster
        }
      })])])])
    })], 2)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d930abd","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-videos/custom-videos.pug
// module id = 727
// module chunks = 1